module.exports = {"id":"172113","name":"Matías Fritzler","rating":"75","photo":"./data/images/photos/3/172113.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MatiasFritzler0.json
// module id = 2877
// module chunks = 0